import { z } from 'zod'
import { GROUPS } from '@Const/groups'

const nameKey = 'name'

const groupsFormKey = 'groups'

const groupsSchema = z.array(
    z.object({
        [nameKey]: z.enum(GROUPS),
    })
)

export { groupsSchema, groupsFormKey }
